import { Toaster, toast } from 'react-hot-toast';
import {colors as ThemeColors} from './Theme.jsx';

const T = () => {
	return (
		<Toaster
			position="top-center"
			containerStyle={{
				marginTop: '4rem',
				zIndex: 9999, // For the container
			}}
			toastOptions={{
				success: {
					style: {
						background: ThemeColors.primary.DEFAULT({}),
						color: ThemeColors.white({}),
					},
					iconTheme: {
						primary: ThemeColors.white({}),
						secondary: ThemeColors.primary.DEFAULT({}),
					}
				},
				error: {
					style: {
						background: ThemeColors.secondary({}),
						color: ThemeColors.white({}),
					},

					iconTheme: {
						primary: ThemeColors.white({}),
						secondary: ThemeColors.secondary({}),
					}
				},
			}} />
	)
}

export default {
	Toaster: T,
	toast: toast
}
